import * as PropTypes from 'prop-types';
import Breadcrumbs from './Breadcrumbs';
import React from 'react';
import StatusChip from '@components/common/StatusChip';
import {AppBar, Box, Typography} from '@mui/material';
import {Helmet} from 'react-helmet-async';
import {useAuth} from '@apps-common/auth-react';
import {useParams} from 'react-router-dom';

const Header = ({
  name,
  subheader,
  breadcrumbs = [],
  children,
  dataQe,
  helmetTitle,
  optional,
}) => {
  const auth = useAuth();
  const {orgId} = useParams();

  const isString = typeof name === 'string';

  const dataTestId = isString ? `${name.toLowerCase()}-page` : '';
  const title = isString ? name : helmetTitle;

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>

      <AppBar
        position="sticky"
        color="default"
        elevation={0}
        sx={{
          backgroundColor: 'background.default',
          pt: 2.5,
          pb: 1.5,
        }}
      >
        {breadcrumbs && <Breadcrumbs breadcrumbs={breadcrumbs} />}

        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={2}
          mt={0.5}
        >
          <Box>
            <Box
              display="flex"
              gap={2}
              sx={{
                alignItems: {xs: 'flex-start', sm: 'center'},
                flexDirection: {xs: 'column', sm: 'row'},
              }}
            >
              <Typography
                variant="h5"
                component="h1"
                fontWeight={600}
                data-testid={dataTestId}
                data-qe={dataQe}
                sx={{wordBreak: 'break-word'}}
              >
                {name}

                {optional && (
                  <Typography
                    color="text.secondary"
                    component="span"
                    variant="h5"
                    sx={{fontWeight: 'normal'}}
                  >
                    {' '}
                    (Optional)
                  </Typography>
                )}
              </Typography>

              {Number(auth.user?.claims.organization_id) === Number(orgId) && (
                <StatusChip
                  label="Your org"
                  statusColor="indigo"
                  disableBorder
                />
              )}
            </Box>

            {subheader && (
              <Typography
                variant="body1"
                component="h2"
                color="textSecondary"
                mt={0.5}
              >
                {subheader}
              </Typography>
            )}
          </Box>

          <Box>{children}</Box>
        </Box>
      </AppBar>
    </>
  );
};

Header.propTypes = {
  children: PropTypes.node,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  breadcrumbs: PropTypes.array,
  subheader: PropTypes.string,
  dataQe: PropTypes.string,
  helmetTitle: PropTypes.string,
  optional: PropTypes.bool,
};

export default Header;
